/* eslint-disable no-console */
import React from 'react';
import {
  number,
  required,
  dynamicMobileValidation,
  auMobValidation
} from '../../utils/validation/index';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import { Field, formValueSelector, change } from 'redux-form';
import RenderTextField from '../../components/form-controls/RenderTextField';
import RenderCommonDropdownField from '../../components/form-controls/RenderCommonDropdownField';
import PropTypes from 'prop-types';
import { FORMNAME_APPLICANT_DETAILS, OTP_WAIT_TIME } from '../../utils/constants';
import {
  getPhoneValidationsByCountry,
  sendOtpOnMobile,
  verifyMobileOtp
} from '../../redux/actions/otp-request/otp-request-action';
import { connect } from 'react-redux';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { updateScreenConfig } from '../../redux/actions/user-flow/user-flow-action';
import { normalizeAll, r_maxLength, r_onlyNumbers } from '../../utils/validation/restrictions';
import { applicantDetailsSubmit } from '../../redux/actions/corporate-user-flow/corporate-user-flow-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { API_URL } from '../../utils/config';
import './mobile-verification.css';
import { FLOW_TYPE_ONBOARDING, OTP_VERIFIED } from '../../utils/constants/eventsConstants';
import CommonButton from '../common-button/CommonButton';
import { logEvent } from '../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../utils/events/eventsConstants';

class MobileVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mob_code: 'Code',
      countdown: OTP_WAIT_TIME,
      inline: null,
      sent: 0,
      counter: 0,
      otpSent: false
    };
    this.timeout = null;
    this.inputRef = null;
  }

  getInputRef = (ref) => (this.inputRef = ref);

  init = async (countryCode) => {
    let { getPhoneValidationsByCountry, mobile_country_code, is_phone_verified, isSignUpView } =
      this.props;
    let response = await getPhoneValidationsByCountry(countryCode, isSignUpView);
    if (response && response.data && response.data.success) {
      this.phoneCode = response.data.data[0].phone_code[0];
      this.setState({ mob_code: `+${response.data.data[0].phone_code[0]}` });
    } else if (mobile_country_code) {
      this.setState({ mob_code: `+${response.data.data[0].phone_code[0]}` });
    }

    if (is_phone_verified) {
      this.setState({
        inline: `${this.inputRef?.inputRef?.current?.value || 'your number'} has been verified`
      });
    }
  };

  isMobileValid = () => {
    let { formSyncErrors } = this.props;
    return !(formSyncErrors && formSyncErrors.mobile_number);
  };

  sendOTP = async () => {
    let { activateLoader, mobile_country_code, disableLoader, showMessage, sendOtpOnMobile } =
      this.props;
    if (!this.isMobileValid()) return;
    try {
      activateLoader();
      let response = await sendOtpOnMobile({
        mobile_country_code: mobile_country_code || this.phoneCode,
        mobile_number: this.inputRef?.inputRef?.current?.value,
        is_send_otp: true
      });
      disableLoader();
      if (response && response.data && response.data.success) {
        await new Promise((resolve) =>
          this.setState({ otpSent: true, counter: this.state.counter + 1 }, resolve)
        );
        this.setTimeout();
        await new Promise((resolve) =>
          this.setState(
            {
              inline: `A verification code has been sent to ${
                this.inputRef?.inputRef?.current?.value || 'your number'
              }`
            },
            resolve
          )
        );
      }
    } catch (e) {
      disableLoader();
      console.error(e);
      showMessage({ text: [JSON.stringify(e)], type: 'error' });
    }
    await new Promise((resolve) => this.setState({ otpSent: false }, resolve));
  };

  resendOTP = async () => {
    if (!this.isMobileValid()) return;
    try {
      await new Promise((resolve) =>
        this.setState({ otpSent: true, counter: this.state.counter + 1 }, resolve)
      );
      const sendOtpOnMobileObj = {
        mobile_country_code: this.phoneCode,
        mobile_number: this.inputRef?.inputRef?.current?.value,
        is_send_otp: true
      };
      if (this.state.counter >= 3) sendOtpOnMobileObj.is_send_otp = false;
      let response = await this.props.sendOtpOnMobile(sendOtpOnMobileObj);
      if (response && response.data && response.data.success) this.setTimeout();
      await new Promise((resolve) =>
        this.setState(
          {
            inline: `A new verification code has been sent to ${
              this.inputRef?.inputRef?.current?.value || 'your number'
            }`
          },
          resolve
        )
      );
    } catch (e) {
      console.error(e);
      this.props.showMessage({ text: [JSON.stringify(e)] }, 'error');
    }
    await new Promise((resolve) => this.setState({ otpSent: false }, resolve));
  };

  setTimeout = () => {
    if (this.timeout) {
      clearInterval(this.timeout);
      this.timeout = null;
    }
    if (this.state.counter < 4)
      this.timeout = setInterval(() => {
        let newVal = this.state.countdown - 1 || OTP_WAIT_TIME;
        if (newVal === OTP_WAIT_TIME) {
          clearInterval(this.timeout);
          this.timeout = null;
        }
        this.setState({ countdown: newVal || OTP_WAIT_TIME });
      }, 1000);
  };

  onMobileCountryCodeChange = async (obj, isSignUpView) => {
    const { dispatch, formName } = this.props;
    if (isSignUpView && obj) {
      dispatch(change(formName, 'mobile_number', ''));
      await this.init(obj.country_code);
    }
    obj &&
      (await this.setState({
        mob_code: '+' + obj.code,
        country_code: obj.country_code
      }));
  };

  onOTPChange = async (e) => {
    let { mobile_number, mobile_country_code, countryCode, formName, verifyMobileOtp, dispatch } =
      this.props;
    if (e.target.value.length === 6) {
      let result = await verifyMobileOtp(
        e.target.value,
        mobile_number,
        mobile_country_code,
        countryCode,
        {
          formID: 'personal-detail-mobile-verify'
        }
      );
      if (result) {
        logEvent(OTP_VERIFIED, FLOW_TYPE_ONBOARDING, {}, LOG_TYPE.CLEVER_TAP);
        if (formName === FORMNAME_APPLICANT_DETAILS) {
          dispatch(
            applicantDetailsSubmit({
              mobile_number,
              mobile_country_code,
              country_of_residence: countryCode
            })
          );
        }
        this.setState({
          inline: `${this.inputRef?.inputRef?.current?.value || 'your number'} has been verified`
        });
        this.props.updateScreenConfig('mobile_verification', {
          is_required: false
        });
      } else await this.setState([{ inline: 'You have entered an incorrect verification code' }]);
    }
  };

  otpValidation = (value) => {
    let error = number(value);
    return error;
  };

  async componentDidMount() {
    let { countryCode } = this.props;
    countryCode && (await this.init(countryCode));
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    let { countryCode, isSignUpView } = nextProps;
    if (!isSignUpView) {
      nextProps.countryCode &&
        nextProps.countryCode !== this.props.countryCode &&
        (await this.init(countryCode));
    }
  }

  render() {
    const {
      disableHeader,
      is_phone_verified,
      disablePinVerification,
      isSignUpView,
      mobile_country_code,
      countryCode,
      formSyncErrors
    } = this.props;
    let mobileNumberCheck = formSyncErrors && formSyncErrors.mobile_number ? false : true;
    const { otpSent, counter, countdown, inline, country_code } = this.state;
    let mobileCountryCodeURL = isSignUpView
      ? `${API_URL}/public/country/phone-code?concat_phone_country_code=true`
      : `${API_URL}/country/phone-code?country_code=${countryCode}`;
    let tooltip =
      countryCode === 'US'
        ? {
            tooltip:
              // eslint-disable-next-line max-len
              'We do not accept registrations using Non-Fixed VOIP phone numbers. Accounts and transactions created with Non-Fixed VOIP phone numbers may be rejected by Instarem'
          }
        : {};
    return (
      <Grid.Row
        className={
          'form-row form-rows common-mobile-verifictaion-page ' +
          (disableHeader ? 'zero-top-padding zero-bottom-padding' : '')
        }
      >
        {!disableHeader && (
          <Grid.Column width={16} key={'mobile-verification-header'}>
            <div className="form-flow-header">{'Contact'}</div>
          </Grid.Column>
        )}
        <Grid.Column computer={7} tablet={8} mobile={16}>
          <div className="mobile-wrapper">
            <Field
              bindToThisObject={mobile_country_code}
              dependedOnObject={isSignUpView ? null : countryCode}
              name="mobile_country_code"
              type="text"
              disabled={is_phone_verified}
              preselect_and_disable_if_one_item={true}
              validate={[required]}
              component={RenderCommonDropdownField}
              placeholder={'Code'}
              isSearchable={isSignUpView}
              isCompact={isSignUpView}
              className={'theme-dropdown'}
              url={mobileCountryCodeURL}
              onDropdownChange={(obj) => this.onMobileCountryCodeChange(obj, isSignUpView)}
              emptyOnNotFound
              selectedLabel={this.state.mob_code}
            />
            <div
              className={
                'first-name-padding mobile_number' + (is_phone_verified ? ' verified_message' : '')
              }
            >
              <Field
                name="mobile_number"
                type="text"
                component={RenderTextField}
                validate={
                  country_code === 'AU' || (!country_code && countryCode === 'AU')
                    ? [auMobValidation, dynamicMobileValidation]
                    : [dynamicMobileValidation]
                }
                normalize={(() => {
                  let restrictions = [],
                    { mobileValidationReducer } = this.props;
                  if (mobileValidationReducer) {
                    if (mobileValidationReducer.type === 'startsWithFour')
                      restrictions.push(r_onlyNumbers);
                    if (mobileValidationReducer.length) {
                      let { max, exact } = mobileValidationReducer.length;
                      restrictions.push(r_maxLength(exact || max));
                    }
                    if (mobileValidationReducer.type === 'number') restrictions.push(r_onlyNumbers);
                    if (mobileValidationReducer.length) {
                      let { max, exact } = mobileValidationReducer.length;
                      restrictions.push(r_maxLength(exact || max || 50));
                    }
                  }
                  return normalizeAll(restrictions);
                })()}
                placeholder={isSignUpView ? "Applicant's mobile number" : 'Mobile number'}
                disabled={is_phone_verified || this.timeout}
                className={`input mobile-number ${isSignUpView ? '' : 'form-flow'}`}
                {...tooltip}
                tip={this.state.inline || ''}
                getInputRef={this.getInputRef}
              />
            </div>
            {is_phone_verified && (
              <div className="mobile-icon-wrapper">
                <Icon name="check" color="white" size="small" />
              </div>
            )}
          </div>
        </Grid.Column>
        {!disablePinVerification && (
          <Grid.Column computer={7} tablet={8} mobile={16}>
            <div className="mobile-wrapper vertical">
              {!is_phone_verified && inline && this.isMobileValid() && (
                <Field
                  name="mobile_otp"
                  type="text"
                  className="input form-flow mobile-number enter-mob-otp"
                  component={RenderTextField}
                  validate={this.otpValidation}
                  normalize={r_maxLength(6)}
                  onChange={this.onOTPChange}
                  placeholder={'Enter verification code'}
                  tip={
                    this.isMobileValid() && !is_phone_verified && this.timeout && counter < 3
                      ? `Request a new verification code after ${countdown} seconds`
                      : ''
                  }
                />
              )}
              {(() => {
                if (
                  !this.inputRef?.inputRef?.current?.value ||
                  !this.isMobileValid() ||
                  otpSent ||
                  this.timeout ||
                  is_phone_verified
                )
                  return null;
                switch (counter) {
                  case 0:
                    return (
                      <CommonButton
                        text="Send verification code"
                        width={250}
                        type="button"
                        height={50}
                        className="mobile-verification-link mob-send-otp"
                        onClick={(e) => {
                          e.preventDefault();
                          this.sendOTP();
                        }}
                        id="send-mob-verification"
                      />
                    );
                  case 1:
                  case 2:
                    return (
                      <CommonButton
                        type="button"
                        text="Resend verification code"
                        className="mobile-verification-link mob-send-otp"
                        onClick={(e) => {
                          e.preventDefault();
                          this.resendOTP();
                        }}
                        id="resend-mob-verification"
                      />
                    );
                  default:
                    return null;
                }
              })()}
            </div>
            {!is_phone_verified && this.props.showMobileOtpBox && mobileNumberCheck ? (
              <p id="otpError">OTP verification mandatory</p>
            ) : null}
          </Grid.Column>
        )}
      </Grid.Row>
    );
  }
}

MobileVerification.propTypes = {
  is_phone_verified: PropTypes.bool,

  getPhoneValidationsByCountry: PropTypes.func,
  sendOtpOnMobile: PropTypes.func,
  verifyMobileOtp: PropTypes.func,
  parent: PropTypes.any,
  showMessage: PropTypes.func,
  countryCode: PropTypes.string,
  updateScreenConfig: PropTypes.func,
  disableHeader: PropTypes.bool,
  mobileValidationReducer: PropTypes.object,
  formSyncErrors: PropTypes.object,
  mobile_country_code: PropTypes.any,
  mobile_number: PropTypes.string,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  disablePinVerification: PropTypes.bool,
  isSignUpView: PropTypes.bool,
  dispatch: PropTypes.any,
  formName: PropTypes.any,
  showMobileOtpBox: PropTypes.bool
};

const mapStateToProps = (reduxState, ownProps) => {
  const {
    rootReducer: {
      userStatusReducer: { is_phone_verified },
      mobileValidationReducer
    }
  } = reduxState;

  const formValues = formValueSelector(ownProps.formName);
  const { mobile_number, mobile_country_code } = formValues(
    reduxState,
    'mobile_number',
    'mobile_country_code'
  );

  return {
    is_phone_verified,
    mobile_number,
    mobile_country_code,
    mobileValidationReducer
  };
};

//Connect form to react-redux
const reactReduxMobileVerification = connect(mapStateToProps, {
  showMessage,
  sendOtpOnMobile,
  verifyMobileOtp,
  getPhoneValidationsByCountry,
  updateScreenConfig,
  activateLoader,
  disableLoader
})(MobileVerification);

export default reactReduxMobileVerification;
